import {z} from 'zod'

export const HexColor = z.string().regex(/#[\da-fA-F]{6}/)
export type HexColor = z.infer<typeof HexColor>
